import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { UserProfileProviderContext } from "./UserProfileProviderContext";

export const useUserProfileProviderContext = () => {
  const context = useContext(UserProfileProviderContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useUserProfileProvider",
      "UserProfileProviderContext"
    );
  }

  return context;
};
